/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
type WidgetContainer_user$ref = any;
type WidgetContainer_widget$ref = any;
type WidgetIconContainer_widget$ref = any;
import type { FragmentReference } from "relay-runtime";
declare export opaque type WidgetsContainer_user$ref: FragmentReference;
declare export opaque type WidgetsContainer_user$fragmentType: WidgetsContainer_user$ref;
export type WidgetsContainer_user = {|
  +id: string,
  +activeWidget: ?string,
  +widgets: ?{|
    +edges: ?$ReadOnlyArray<?{|
      +node: ?{|
        +id: string,
        +type: ?string,
        +$fragmentRefs: WidgetContainer_widget$ref & WidgetIconContainer_widget$ref,
      |}
    |}>
  |},
  +$fragmentRefs: WidgetContainer_user$ref,
  +$refType: WidgetsContainer_user$ref,
|};
export type WidgetsContainer_user$data = WidgetsContainer_user;
export type WidgetsContainer_user$key = {
  +$data?: WidgetsContainer_user$data,
  +$fragmentRefs: WidgetsContainer_user$ref,
};
*/


const node/*: ReaderFragment*/ = (function(){
var v0 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
};
return {
  "kind": "Fragment",
  "name": "WidgetsContainer_user",
  "type": "User",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    (v0/*: any*/),
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "activeWidget",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "widgets",
      "storageKey": "widgets(enabled:true,first:20)",
      "args": [
        {
          "kind": "Literal",
          "name": "enabled",
          "value": true
        },
        {
          "kind": "Literal",
          "name": "first",
          "value": 20
        }
      ],
      "concreteType": "WidgetConnection",
      "plural": false,
      "selections": [
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "edges",
          "storageKey": null,
          "args": null,
          "concreteType": "WidgetEdge",
          "plural": true,
          "selections": [
            {
              "kind": "LinkedField",
              "alias": null,
              "name": "node",
              "storageKey": null,
              "args": null,
              "concreteType": "Widget",
              "plural": false,
              "selections": [
                (v0/*: any*/),
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "type",
                  "args": null,
                  "storageKey": null
                },
                {
                  "kind": "FragmentSpread",
                  "name": "WidgetContainer_widget",
                  "args": null
                },
                {
                  "kind": "FragmentSpread",
                  "name": "WidgetIconContainer_widget",
                  "args": null
                }
              ]
            }
          ]
        }
      ]
    },
    {
      "kind": "FragmentSpread",
      "name": "WidgetContainer_user",
      "args": null
    }
  ]
};
})();
// prettier-ignore
(node/*: any*/).hash = 'e3b6f600329cff6495ef999c25d4b03f';
module.exports = node;
